<template>
  <div>
    <div class="delivery-container">
      <div class="grid-row">
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('delivery_address')}} *</label>
            <Input
              :type="'text'"
              ref="tadr1l"
              :uppercase="true"
              :required="true"
              :maxlength="25"
              @typing="vSetStore('tadr1l', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>&nbsp;</label>
            <Input
              :type="'text'"
              :uppercase="true"
              :maxlength="25"
              @typing="vSetStore('tadr2l', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>&nbsp;</label>
            <Input
              :type="'text'"
              :uppercase="true"
              :maxlength="25"
              @typing="vSetStore('tadr3l', $event.toUpperCase())"
            />
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('postal_code')}} *</label>
            <Input
              :type="'text'"
              ref="tcpostl"
              :uppercase="true"
              :required="true"
              :maxlength="10"
              @typing="vSetStore('tcpostl', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('city')}} *</label>
            <Input
              :type="'text'"
              ref="tvillel"
              :uppercase="true"
              :required="true"
              :maxlength="30"
              @typing="vSetStore('tvillel', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('country')}} *</label>
            <Select
              :placeholder="$_('your_choice')"
              :itemoption="['TCPAYS', 'TLIB_PAYS']"
              :data="country_l"
              :search="true"
              :required="true"
              ref="tcpaysl"
              @select-change="vLoadDistrict($event, 'l')"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('district')}}</label>
            <Select
              :placeholder="$_('your_choice')"
              :itemoption="['TCPROV', 'TLIB_PROV']"
              :data="district_l"
              :search="true"
              :resetselect="reset_district_l"
              @select-change="vSetStore('tcprovl', $event.item)"
            />
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-12 no-gutter">
          <div class="btn-add-list">
            <span @click="billing = !billing">+ {{$_('add_fact_addr')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="delivery-container" v-if="billing">
      <div class="grid-row">
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('billing_address')}} *</label>
            <Input
              :type="'text'"
              ref="tadr1f"
              :uppercase="true"
              :required="true"
              :maxlength="25"
              @typing="vSetStore('tadr1f', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>&nbsp;</label>
            <Input
              :type="'text'"
              ref="tadr2f"
              :uppercase="true"
              :maxlength="25"
              @typing="vSetStore('tadr2f', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>&nbsp;</label>
            <Input
              :type="'text'"
              ref="tadr3f"
              :uppercase="true"
              :maxlength="25"
              @typing="vSetStore('tadr3f', $event.toUpperCase())"
            />
          </div>
        </div>
      </div>
      <div class="grid-row">
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('postal_code')}} *</label>
            <Input
              :type="'text'"
              ref="tcpostf"
              :uppercase="true"
              :required="true"
              :maxlength="10"
              @typing="vSetStore('tcpostf', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field">
            <label>{{$_('city')}} *</label>
            <Input
              :type="'text'"
              ref="tvillef"
              :uppercase="true"
              :required="true"
              :maxlength="30"
              @typing="vSetStore('tvillef', $event.toUpperCase())"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('country')}} *</label>
            <Select
              :placeholder="$_('your_choice')"
              :itemoption="['TCPAYS', 'TLIB_PAYS']"
              :data="country_f"
              :search="true"
              ref="tcpaysf"
              :required="true"
              @select-change="vLoadDistrict($event, 'f')"
            />
          </div>
        </div>
        <div class="c-2 c-xs-12 c-sm-12 c-md-2 c-lg-2">
          <div class="form-field no-margin">
            <label>{{$_('district')}}</label>
            <Select
              :placeholder="$_('your_choice')"
              :itemoption="['TCPROV', 'TLIB_PROV']"
              :data="district_f"
              :search="true"
              :resetselect="reset_district_f"
              @select-change="vSetStore('tcprovf', $event.item)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/common/components/widget/Input/Input";
import Select from "@/common/components/widget/Select";

import customerService from "@/modules/client/services/customerService";

export default {
  name: "ProspectFormDelivery",
  data() {
    return {
      country_l: Array(),
      country_f: Array(),
      district_l: Array(),
      district_f: Array(),
      reset_district_l: false,
      reset_district_f: false,
      billing: false
    };
  },
  components: {
    Input,
    Select
  },
  created() {
    customerService.getCountry().then(res => {
      this.country_l = res.data.DS_O.OUT;
      this.country_f = res.data.DS_O.OUT;
    });
  },
  methods: {
    vSetStore(key, value) {
      this.$store.dispatch("echantillon/SET_HEADER", { key, value });
    },
    vLoadDistrict(event, mode) {
      if (mode === "l") {
        this.vSetStore("tcpaysl", event.item);

        this.reset_district_l = true;

        customerService.getDistrict(event.item).then(res => {
          this.district_l = res.data.DS_O.OUT;
          this.reset_district_l = false;
        });
      } else if (mode === "f") {
        this.vSetStore("tcpaysf", event.item);

        this.reset_district_f = true;

        customerService.getDistrict(event.item).then(res => {
          this.district_f = res.data.DS_O.OUT;
          this.reset_district_f = false;
        });
      }
    }
  }
};
</script>

<style scoped>
.delivery-container {
  padding: 20px;
  border: solid 1px #e1e1e1;
  border-radius: 8px;
}
.delivery-container:first-child {
  margin-bottom: 30px
}
@media screen and (max-width: 800px) {
  .delivery-container {
    padding: 0px 0px 15px 0px
  }
}
</style>